import React from 'react';
import { AlertCircle } from 'lucide-react';

const Disclaimer = () => {
  return (
    <section className="section-padding" style={{ background: 'var(--bg-section)', borderTop: '1px solid var(--border-light)' }}>
      <div className="container">
        <div className="max-w-4xl mx-auto">
          <div className="voice-card accent-grey" style={{ padding: '2rem' }}>
            <div className="flex items-start gap-3 mb-4">
              <AlertCircle size={24} style={{ color: 'var(--text-primary)', flexShrink: 0, marginTop: '2px' }} />
              <h3 className="heading-2">Medical Disclaimer & Terms of Use</h3>
            </div>

            <div className="space-y-4 body-small" style={{ color: 'var(--text-secondary)' }}>
              <p>
                <strong>Important Notice:</strong> The information provided on this website is for general informational 
                and educational purposes only. It is not intended to be a substitute for professional medical advice, 
                diagnosis, or treatment.
              </p>

              <p>
                <strong>No Doctor-Patient Relationship:</strong> Use of this website and communication with our team does 
                not create a doctor-patient relationship. All medical decisions should be made in consultation with qualified 
                healthcare professionals.
              </p>

              <p>
                <strong>Limitation of Liability:</strong> MediTourism India acts solely as a facilitator connecting patients 
                with healthcare providers. We are not liable for:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '2rem', marginTop: '0.5rem' }}>
                <li>Medical outcomes, complications, or adverse events arising from any medical procedure</li>
                <li>Quality of medical services provided by partner hospitals or doctors</li>
                <li>Travel arrangements, visa processing, accommodation, or logistics issues</li>
                <li>Changes in treatment costs, hospital policies, or service availability</li>
                <li>Loss, damage, or delays related to travel or medical documentation</li>
                <li>Any indirect, incidental, or consequential damages</li>
              </ul>

              <p>
                <strong>Patient Responsibility:</strong> Patients are responsible for:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '2rem', marginTop: '0.5rem' }}>
                <li>Verifying credentials and qualifications of healthcare providers</li>
                <li>Understanding all risks and benefits of proposed medical procedures</li>
                <li>Obtaining comprehensive travel and medical insurance</li>
                <li>Complying with all medical advice, pre-operative and post-operative instructions</li>
                <li>Making informed decisions about their healthcare</li>
              </ul>

              <p>
                <strong>Accuracy of Information:</strong> While we strive to provide accurate and up-to-date information, 
                we do not guarantee the completeness, accuracy, or reliability of any content. Medical information, costs, 
                and hospital details are subject to change without notice.
              </p>

              <p>
                <strong>Third-Party Services:</strong> We are not responsible for the actions, content, or services of 
                third-party hospitals, doctors, travel agencies, or other service providers. Any agreements or transactions 
                with third parties are solely between you and that party.
              </p>

              <p>
                <strong>Indemnification:</strong> By using our services, you agree to indemnify and hold harmless 
                Curis Path, its officers, directors, employees, and agents from any claims, damages, losses, 
                or expenses arising from your use of our services or medical treatment obtained through our facilitation.
              </p>

              <p>
                <strong>Governing Law:</strong> These terms shall be governed by and construed in accordance with the 
                laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in New Delhi, India.
              </p>

              <p style={{ marginTop: '1.5rem', fontStyle: 'italic' }}>
                By submitting an enquiry or using our services, you acknowledge that you have read, understood, and 
                agree to these terms and conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;